import React, {useState} from 'react'
import {getRoleById, updateRole} from "../../services/serviceRole";
import {Button, Form, Input, message, Modal} from "antd";
import {EditOutlined} from "@ant-design/icons";
import config from "../../config";

const RoleEdit = ({roleId, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)

    const handleEditClick = () => {
        if(config.protectedVariables.roleId.includes(roleId)){
            message.error('Bu işlem yapılamaz')
        }else {
            getRoleById(roleId)
                .then(({data}) => {
                    form.setFieldsValue({
                        roleName: data.name,
                        roleCode: data.code
                    })
                    setEditModal(!editModal)
                })
        }
    }

    const handleSubmit = (list) => {
        let requestObj = {
            name: list.roleName,
            code: list.roleCode,
            id: roleId
        }
        updateRole(requestObj)
            .then(() => {
                setEditModal(!editModal)
                updater()
            })
    }
    const formLayout = {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
    }

    return (
        <React.Fragment>
            <Button
                className={'btn-edit'}
                onClick={() => handleEditClick()}
            ><EditOutlined/></Button>

            <Modal
                open={editModal}
                onCancel={() => setEditModal(!editModal)}
                title={`Güncelle`}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        onClick={() => handleSubmit(form.getFieldsValue())}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={() => setEditModal(!editModal)}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'roleName'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Kodu'}
                        name={'roleCode'}
                    >
                        <Input />
                    </Form.Item>

                </Form>


            </Modal>
        </React.Fragment>
    )
}
export default RoleEdit